<script setup lang="ts">
import { MAIN_NAV_ITEMS, type MainNavPage } from "@/navigation/mainNavigation";

defineProps<{
  activePage: MainNavPage;
}>();

defineEmits<{
  navigate: [page: MainNavPage];
}>();
</script>

<template>
  <nav class="mobile-primary-nav" aria-label="移动端主导航">
    <button
      v-for="item in MAIN_NAV_ITEMS"
      :key="item.key"
      type="button"
      :class="{ 'is-active': activePage === item.key }"
      :aria-current="activePage === item.key ? 'page' : undefined"
      :aria-label="`${item.label}：${item.description}`"
      @click="$emit('navigate', item.key)"
    >
      <svg v-if="item.key === 'nebula'" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5.5 16.5A4.5 4.5 0 0 1 7 7.8a5.5 5.5 0 0 1 10.4 2.3A3.5 3.5 0 0 1 17 17H7.2" />
        <path d="m12 9 .7 1.6 1.7.2-1.3 1.2.4 1.8-1.5-.9-1.5.9.4-1.8-1.3-1.2 1.7-.2L12 9Z" />
      </svg>
      <svg v-else-if="item.key === 'map'" viewBox="0 0 24 24" aria-hidden="true">
        <path d="m3.5 5.5 5-2 7 2 5-2v15l-5 2-7-2-5 2v-15Z" />
        <path d="M8.5 3.5v15M15.5 5.5v15" />
      </svg>
      <svg v-else-if="item.key === 'reposition'" viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3.5" y="4.5" width="17" height="15" rx="2" />
        <circle cx="9" cy="10" r="1.6" />
        <path d="m5.5 17 4.3-4.2 3.2 2.8 2.6-2.3 3 3" />
      </svg>
      <svg v-else-if="item.key === 'crowdsource'" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="9" cy="8" r="3" />
        <circle cx="17" cy="9" r="2.3" />
        <path d="M3.5 19c.5-4 2.3-6 5.5-6s5 2 5.5 6M14 14c3.7-.5 5.8 1.2 6.5 4.5" />
      </svg>
      <svg v-else viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 20V9" />
        <path d="M12 12C7.5 12 5 9.5 5 5c4.5 0 7 2.5 7 7ZM12 15c4.5 0 7-2.5 7-7-4.5 0-7 2.5-7 7Z" />
      </svg>
      <span class="primary-nav-label">{{ item.label }}</span>
      <span class="primary-nav-tooltip" aria-hidden="true">{{ item.description }}</span>
    </button>
  </nav>
</template>
